<p-dialog
  [(visible)]="visible"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '100%', bottom: '0', left: '0', right: '0', position: 'fixed', margin: '0' }"
  [contentStyle]="{ height: 'auto', width: '100%' }"
  position="bottom"
  [baseZIndex]="10000">
  <div class="bg-light p-3 pb-5">
    <div class="text-center bold text-20 pb-3 pt-2">Open with</div>
    <div class="buttons-layout">
      <!-- app -->
      <img class="open-app-icon" src="assets/logos/mab-icon.png" alt="logo" />
      <div class="bold ml-2">MAB Landlord App</div>
      <button pButton class="m-a p-button p-button-primary p-button-outline centered w-100 py-2" (click)="openApp()" size="small">
        Open
      </button>
      <!-- Continue Web -->
      <img class="open-app-icon" src="assets/icons/globe.svg" alt="web" />
      <div class="bold ml-2">Continue in browser</div>
      <button pButton class="m-a p-button p-button-outline centered w-100 py-2" (click)="cancel()">Continue</button>
    </div>
  </div>
</p-dialog>
